'use client';

import { MLPEventCard } from '@/components/molecules/MLPEventCard';
import { LeagueCardSkeleton } from '@/components/molecules/skeletons/LeagueCardSkeleton';
import { MLPStripData } from '@/entities/MLPStripData';
import { useMLPStripQuery } from '@/hooks/hooks';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';

export const MLPCarousel = () => {
	const { data: MLPStripEvents, isLoading } = useMLPStripQuery();

	const containerRef = React.useRef<HTMLDivElement>(null);

	const scroll = React.useCallback((direction: 'left' | 'right') => {
		const div = containerRef.current;
		if (div) {
			const position = direction === 'right' ? div.scrollLeft + 250 : div.scrollLeft - 250;
			const maxScrollLeft = div.scrollWidth - div.clientWidth;
			const left = direction === 'right' ? (position < maxScrollLeft ? position : maxScrollLeft) : position < 0 ? 0 : position;
			div.scrollTo({ left, behavior: 'smooth' });
		}
	}, []);

	if (isLoading) {
		return (
			<div className="mx-auto flex flex-col justify-center max-w-screen-2xl my-10">
				<LeagueCardSkeleton />
			</div>
		);
	}

	if ((MLPStripEvents?.data?.length == 0 || MLPStripEvents?.statusCode !== 200) && !isLoading) {
		return null;
	}

	return (
		<div className="carouselStyle h-full py-10">
			<div className="mx-auto flex flex-col justify-center w-full">
				<>
					<div className="flex items-center justify-between px-4">
						<div className="text-2xl font-semibold text-white">MLP</div>
						<div className="flex gap-4">
							<div
								onClick={() => scroll('left')}
								className="prev-scroll z-10 flex size-10 cursor-pointer items-center justify-center rounded-full border border-white transition duration-150 hover:bg-blue-500 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-300 disabled:hover:bg-gray-100 lg:-left-6"
							>
								<FontAwesomeIcon icon={faArrowLeft} className="block text-white" />
							</div>
							<div
								onClick={() => scroll('right')}
								className="prev-scroll z-10 flex size-10 cursor-pointer items-center justify-center rounded-full border border-white transition duration-150 hover:bg-blue-500 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-300 disabled:hover:bg-gray-100 lg:-left-6"
							>
								<FontAwesomeIcon icon={faArrowRight} className="block text-white" />
							</div>
						</div>
					</div>
					<div className="no-scrollbar mt-6 flex snap-x snap-mandatory gap-6 overflow-x-auto px-4" ref={containerRef}>
						{MLPStripEvents?.data?.map((event: MLPStripData, index) => {
							return <MLPEventCard key={`${event.uuid} ${event.title} ${index}`} event={event} />;
						})}
					</div>
				</>
			</div>
		</div>
	);
};
